import styled from 'styled-components';

export const Wrapper = styled.div`
  .post-link {
    display: inline-block;
    color: var(--indigo-1);
    &:hover {
      color: var(--indigo-3);
    }
  }
  .simple-code {
    background-color: ${({ theme }) =>
      theme ? theme.hover.background : 'var(--light-gray-2)'};
    padding: 1px 4px;
    color: ${({ theme }) => (theme ? theme.text : '#000')};
    font-size: 0.9rem;
    font-style: normal;
    font-family: 'Droid Sans Mono', 'Inconsolata', 'Menlo', 'Consolas',
      'Bitstream Vera Sans Mono', 'Courier', monospace;
    display: inline-block;
  }
  h3 .simple-code {
    padding: 0.4rem;
  }
  h2 .simple-code {
    padding: 0.5rem;
  }
  .code-dark {
    background-color: rgb(45, 45, 45);
  }

  ul,
  ol {
    list-style: unset;
    margin: 0.5rem 0 0.5rem 1rem;
  }
  .post-image {
    display: block;
    width: 100%;
    max-width: 600px;
    margin: 1rem auto;
  }
  h2,
  h3,
  h4,
  h5,
  h6 {
    opacity: 0.85;
  }
  p {
    margin: 0;
    line-height: 1.6;
  }
  p input[type='checkbox'] {
    margin-bottom: 1.5rem;
  }
  pre {
    margin-bottom: 1rem;
  }

  input[type='checkbox'] {
    margin-bottom: 0.6rem;
    display: inline-block;
  }

  blockquote {
    border-left: 3px solid var(--success);
    font-family: 'Lora', serif;
    font-style: italic;
    line-height: 1.6em;
    margin-right: 2rem;
    padding: 1rem 0.5rem 1rem 1.5rem;
    font-size: 1rem;
    margin-bottom: 1rem;
    border-left: 5px solid var(--green-1);
    z-index: 0;
  }
  blockquote code {
    font-size: 1em;
  }

  blockquote > :last-child {
    margin-bottom: var(--spacing-0);
  }

  blockquote > ul,
  blockquote > ol {
    list-style-position: inside;
  }

  table {
    width: 100%;
    margin: 1rem 0;
    border: 1px solid var(--light-gray-1);
    box-shadow: var(--lightShadow);
    border-radius: 0.4rem;
  }

  table thead tr th {
    border-bottom: 1px solid var(--color-accent);
  }

  table thead {
    background: linear-gradient(
      to right,
      #0d6efdcc 0%,
      #0d6efdcc 50%,
      #6610f2bf 100%
    );
    color: var(--white);
    font-weight: bold;
  }

  thead th {
    color: white;
  }
  tr td:not(last-child) {
    border-right: 1px solid var(--gray-light);
  }

  tbody tr:hover {
    background-color: ${({ theme }) =>
      theme ? theme.hover.background : 'var(--light-gray-2)'};
  }
`;

export const ButtonCopyClipboard = styled.button`
  position: absolute;
  top: 0.5rem;
  right: 0.75rem;
  outline: none;
  background: transparent;
  color: var(--light-gray-1);
  padding: 0.15rem 0.25rem;
  border: 1px solid #68bd69;
  border-radius: 3px;
  cursor: pointer;
  opacity: 0;
  visibility: hidden;
  transition: var(--mainTransition);
  &:hover {
    box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.8);
  }
`;

export const Code = styled.div`
  position: relative;
  .code {
    position: relative;
    max-height: 600px;
    overflow: auto;
  }
  .code *::selection {
    background-color: #505050;
  }
  &:hover ${ButtonCopyClipboard} {
    opacity: 1;
    visibility: visible;
  }
`;
